import Filter from "../../../../models/Filter";
import { dbIndex, pathogenicityDbs } from "../../constants/dbs";
import {
  impactCategories,
  impactIndex,
  impactLabels,
} from "../../constants/pathogenicity";

function getFilters(colorByKeys, selectedColorBy) {
  const { colorByPathogenicity, colorByImpact, colorBy } = colorByKeys;
  const ciCat = "Coding Impact";
  const isVisible = true;

  const allImpactCategories = Object.keys(impactIndex)
    .map((x) => impactCategories[x])
    .filter(Boolean)
    .reduce((a, i) => a.add(i), new Set());

  const impactCats = Array.from(allImpactCategories.values())
    .map((x) => ({ key: x, label: x, isVisible, category: ciCat }))
    .map((x) => ({ ...x, type: "checkbox" }))
    .map((x) => new Filter(x));

  const impactFilters = Object.keys(impactIndex)
    .map((x) => ({ ind: x, key: impactIndex[x] }))
    .map(({ key, ind }) => ({ ind, key, isVisible, label: impactLabels[key] }))
    .map((x) => ({ ...x, category: impactCategories[x.ind] || ciCat }))
    .map((x) => new Filter(x));

  const colorByFilter = new Filter({
    label: "Color By",
    key: colorBy,
    isVisible: true,
    totalCount: 1,
    value: selectedColorBy,
    options: [colorByPathogenicity, colorByImpact].map((x) => ({
      key: x,
      label: x,
    })),
    type: "select",
  });

  const dbFilters = Object.values(pathogenicityDbs)
    .map((x) => ({
      label: x.name,
      key: dbIndex[x.key],
      category: "Pathogenicity DBs",
    }))
    .map((x) => new Filter(x));

  return {
    dbFilters,
    impactFilters: [...impactCats, ...impactFilters],
    colorByFilters: [colorByFilter],
  };
}

export default getFilters;
